const template = {
  name: "Default NEC3 SSC v4.2 18/07/2025",
  isSystemDefault: true,
  isGlobal: true,
  companies: [],
  resources: [
    {
      id: 1,
      type: "TEXT",
      key: "SUPPLIER_NAME",
      value: "Supplier"
    },
    {
      id: 2,
      type: "TEXT",
      key: "SUPPLIER_ABBREVIATION",
      value: "S"
    },
    {
      id: 3,
      type: "TEXT",
      key: "PM_NAME",
      value: "Purchaser"
    },
    {
      id: 4,
      type: "TEXT",
      key: "PM_ABBREVIATION",
      value: "P"
    },
    {
      id: 5,
      type: "TEXT",
      key: "SUPERVISOR_NAME",
      value: "Supervisor"
    },
    {
      id: 6,
      type: "TEXT",
      key: "SUPERVISOR_ABBREVIATION",
      value: "SUP"
    },
    {
      id: 7,
      type: "TEXT",
      key: "CLIENT_NAME",
      value: "Employer"
    },
    {
      id: 8,
      type: "NUMBER",
      key: "SUPPLIER_REPLY_PERIOD",
      value: 21
    },
    {
      id: 9,
      type: "NUMBER",
      key: "PM_REPLY_PERIOD",
      value: 35
    },
    {
      id: 10,
      type: "NUMBER",
      key: "QUOTE_DURATION",
      value: 14
    },
    {
      id: 13,
      type: "NUMBER",
      key: "REQUOTE_DURATION",
      value: 14
    },
    {
      id: 11,
      type: "NUMBER",
      key: "QUOTE_RESPONSE",
      value: 14
    },
    {
      id: 14,
      type: "NUMBER",
      key: "REQUOTE_RESPONSE",
      value: 14
    },
    {
      id: 12,
      type: "NUMBER",
      key: "VARIATION_RESPONSE",
      value: 7
    },
    {
      id: 18,
      type: "TEXT",
      key: "COMPLETION_DATE",
      value: "Delivery Date"
    },
    {
      id: 20,
      type: "NUMBER",
      key: "QUOTE_DURATION_PRIOR_REPLY",
      value: 7
    }
  ],
  workflowGroups: [
    {
      id: 101,
      title: "Early Warnings",
      workflows: [
        {
          id: 1,
          title: "$PM_NAME Early Warnings",
          notificationName: "Early Warning",
          abbreviation: "$PM_ABBREVIATION-Warning-",
          notify: true,
          replyEnabled: true,
          assetFieldsEnabled: false,
          replyPeriodOption: "SUPPLIER_REPLY_PERIOD",
          replyPeriod: 0,
          notifyingParty: "PM",
          replyingParty: "SUPPLIER",
          actioningParty: "PM",
          resolveActioningParty: "PM",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          replyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
              communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            replyNotice: {
              saveDraftReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              communicateReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
            },
            actionTab: {
              actionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]",
            resolveActionTab: {
              resolveActionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
            }
          }
        },
        {
          id: 2,
          title: "$SUPPLIER_NAME Early Warnings",
          notificationName: "Early Warning",
          abbreviation: "$SUPPLIER_ABBREVIATION-Warning-",
          notify: true,
          replyEnabled: true,
          assetFieldsEnabled: false,
          replyPeriodOption: "PM_REPLY_PERIOD",
          replyPeriod: 0,
          notifyingParty: "SUPPLIER",
          replyingParty: "PM",
          actioningParty: "PM",
          resolveActioningParty: "PM",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          replyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
              communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            replyNotice: {
              saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
            },
            actionTab: {
              actionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]",
            resolveActionTab: {
              resolveActionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
            }
          }
        },
        {
          id: 3,
          title: "Early Warning Register",
          notificationName: "Early Warning",
          abbreviation: "Warning",
          overrideResources: null,
          userFilters: {
            accessFilter: "null"
          }
        }
      ],
      placeholders: [
        {
          replacementKey: "Resources",
          values: [
            {
              id: 1,
              isActive: true,
              field: "MeetingRequiredLabel",
              display: "Is a risk reduction meeting required?",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "NotificationClause",
              display: "You are given early warning of a matter which could",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "RiskItemsLabel",
              display: "You are given early warning of a matter which could",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "RiskTypes",
          values: [
            {
              id: 1,
              isActive: true,
              field: "riskincreaseprice",
              display: "increase the total of the Prices",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "riskservicetiming",
              display: "interfere with the timing of the supply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "riskserviceperformance",
              display: "impair the performance of the goods in use",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "RiskTypesSupplier",
          values: [
            {
              id: 2,
              isActive: true,
              field: "riskincreaseprice",
              display: "increase the total of the Prices",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "riskservicetiming",
              display: "interfere with the timing of the supply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: true,
              field: "riskserviceperformance",
              display: "impair the performance of the goods in use",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: true,
              field: "riskincreasecontractorcost",
              display: "increase the $SUPPLIER_NAME's total cost",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "MeetingOptions",
          values: [
            {
              id: 1,
              isActive: false,
              field: "0",
              display: "Extra meeting not required",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "1",
              display: "To be discussed at the next scheduled risk reduction meeting",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "2",
              display: "Propose risk reduction meeting",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ActionReminders",
          values: [
            {
              id: 1,
              isActive: true,
              field: "Pm",
              display: "$WF_1_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "Supplier",
              display: "$WF_2_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "Client",
              display: "$WF_74_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "RiskStatusOptions",
          values: [
            {
              id: 1,
              isActive: true,
              field: "Mitigated",
              display: "Mitigated",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "NotMitigated",
              display: "Not mitigated",
              overrideResources: null,
              postActions: null
            }
          ]
        }
      ]
    },
    {
      id: 102,
      title: "Instructions",
      workflows: [
        {
          id: 4,
          title: "$PM_NAME Instruction",
          notificationName: "Instruction",
          abbreviation: "$PM_ABBREVIATION-Instruction-",
          notify: true,
          replyEnabled: false,
          assetFieldsEnabled: false,
          replyPeriodOption: "SUPPLIER_REPLY_PERIOD",
          replyPeriod: 0,
          resubmitPeriodOption: "PM_REPLY_PERIOD",
          resubmitPeriod: 0,
          notifyingParty: "PM",
          replyingParty: "SUPPLIER",
          form_IncludeCompanyName: false,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          replyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
              communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            replyNotice: {
              saveDraftReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              communicateReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"]]"
          }
        }
      ],
      placeholders: [
        {
          replacementKey: "InstructionTypes",
          values: [
            {
              id: 2,
              isActive: true,
              field: "",
              display: "14.1 to change the Goods Information",
              overrideResources: null,
              postActions: [
                {
                  askUser: true,
                  daysForAction: 0,
                  action: "CREATE",
                  ownerParty: "PM",
                  actionType: "WF_5",
                  timePeriod: "CUSTOM"
                }
              ]
            },
            {
              id: 3,
              isActive: true,
              field: "",
              display: "14.2 to change the Delivery Date",
              overrideResources: null,
              postActions: [
                {
                  askUser: true,
                  daysForAction: 0,
                  action: "CREATE",
                  ownerParty: "PM",
                  actionType: "WF_5",
                  timePeriod: "CUSTOM"
                }
              ]
            },
            {
              id: 11,
              isActive: true,
              field: "",
              display: "31.1 to stop or not start work",
              overrideResources: null,
              postActions: [
                {
                  askUser: true,
                  daysForAction: 0,
                  action: "CREATE",
                  ownerParty: "PM",
                  actionType: "WF_5",
                  timePeriod: "CUSTOM"
                }
              ]
            },
            {
              id: 18,
              isActive: true,
              field: "",
              display: "31.1 to start or restart work",
              overrideResources: null,
              postActions: null
            },
            {
              id: 12,
              isActive: true,
              field: "",
              display: "43.2 to change the Good Information, the Prices and the Delivery Date in respect of an Accepted Defect",
              overrideResources: null,
              postActions: null
            },
            {
              id: 13,
              isActive: true,
              field: "",
              display: "82.1 to not replace lost goods or not repair damaged goods",
              overrideResources: null,
              postActions: null
            },
            {
              id: 17,
              isActive: true,
              field: "",
              display: "Other Instruction",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "Resources",
          values: []
        },
        {
          replacementKey: "ReplyOptions",
          values: [
            {
              id: 1,
              isActive: true,
              field: "Accepted",
              display: "Accepted",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "Accepted with comments",
              display: "Accepted with comments",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "Not Accepted",
              display: "Not Accepted",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "Reply Not Required",
              display: "Reply Not Required",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ActionReminders",
          values: [
            {
              id: 1,
              isActive: true,
              field: "PM",
              display: "$WF_4_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "Supervisor",
              display: "$WF_61_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "Client",
              display: "$WF_56_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            }
          ]
        }
      ]
    },
    {
      id: 114,
      title: "Batch Orders",
      workflows: [
        {
          id: 62,
          title: "$PM_NAME Request For Quote",
          notificationName: "Request For Quote",
          abbreviation: "RFQ-",
          notify: true,
          financialLimitEnabled: false,
          assetFieldsEnabled: false,
          notifyingParty: "PM",
          quotingParty: "SUPPLIER",
          quoteReplyingParty: "PM",
          quoteNotificationName: "Batch-Quote",
          quoteReferencePrefix: "Batch-Quote-",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
              communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            quoteMainNotice: {
              createQuoteFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              communicateQuoteFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            quoteReplyNotice: {
              saveQuoteDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              communicateQuoteReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
          }
        },
        {
          id: 38,
          title: "$PM_NAME Batch Orders",
          notificationName: "Batch Order",
          abbreviation: "Batch-",
          notify: true,
          financialLimitEnabled: false,
          assetFieldsEnabled: false,
          notifyingParty: "PM",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
              communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
          }
        }
      ],
      placeholders: [
        {
          replacementKey: "Resources",
          values: [
            {
              id: 1,
              isActive: true,
              field: "Note",
              display: "Your quote is accepted as set out below, or we make our own assessment as set out below and we notify as follows",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "DescriptionLabel",
              display: "Detailed description of the work in the batch",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "ItemsListLabel",
              display: "Items taken from price list",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "TotalListPriceLabel",
              display: "Price list total",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: true,
              field: "CompensationDescriptionLabel",
              display: "Items assessed in the same way as a compensation event",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: true,
              field: "TotalAssessedLabel",
              display: "Assessed list total",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              isActive: true,
              field: "TotalPriceLabel",
              display: "Total of prices",
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              isActive: true,
              field: "StartDateLabel",
              display: "Start Date",
              overrideResources: null,
              postActions: null
            },
            {
              id: 9,
              isActive: true,
              field: "CompletionDateLabel",
              display: "Delivery Date",
              overrideResources: null,
              postActions: null
            },
            {
              id: 10,
              isActive: true,
              field: "DelayAmountLabel",
              display: "Amount of delay damages for the late completion of the batch",
              overrideResources: null,
              postActions: null
            },
            {
              id: 11,
              isActive: true,
              field: "DelayPaymentPeriodLabel",
              display: "Delay damages period",
              overrideResources: null,
              postActions: null
            },
            {
              id: 12,
              isActive: true,
              field: "WarningBanner",
              display: "",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "Fields",
          values: [
            {
              id: 1,
              isActive: true,
              field: "Description",
              display: "Description of the goods in the batch",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "ItemsList",
              display: "Total quantity",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "TotalListPrice",
              display: "Total price",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: false,
              field: "CompensationDescription",
              display: "Items assessed in the same way as a compensation event",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: false,
              field: "TotalAssessed",
              display: "Assessed list total",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: true,
              field: "TotalPrice",
              display: "Total of prices",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              isActive: true,
              field: "StartDate",
              display: "Start Date",
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              isActive: true,
              field: "CompletionDate",
              display: "Delivery Date",
              overrideResources: null,
              postActions: null
            },
            {
              id: 9,
              isActive: false,
              field: "DelayAmount",
              display: "Amount of delay damages for the late completion of the task",
              overrideResources: null,
              postActions: null
            },
            {
              id: 10,
              isActive: false,
              field: "DelayPaymentPeriod",
              display: "Payment period",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "RFQRelationEnabled",
          values: [
            {
              id: 1,
              isActive: true,
              field: "RFQRelationEnabled",
              display: "Active-Inactive state indicates weather the RFQ can be attached in Task Order communications",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "RFQStatuses",
          values: [
            {
              id: 1,
              isActive: true,
              field: "APMA",
              display: "Awaiting $WF_38_NOTIFICATION_NAME",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "ARQ",
              display: "Quote Not Accepted - $SUPPLIER_NAME to resubmit",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "AM",
              display: "$PM_ABBREVIATION Assessment Made",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "QA",
              display: "Quote Accepted",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: true,
              field: "APMRQ",
              display: "Awaiting $PM_ABBREVIATION Response to quote",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: true,
              field: "APMR",
              display: "Awaiting $PM_ABBREVIATION Response to CEN",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              isActive: true,
              field: "AQ",
              display: "Awaiting Quote",
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              isActive: true,
              field: "NC",
              display: "Not Communicated",
              overrideResources: null,
              postActions: null
            },
            {
              id: 9,
              isActive: true,
              field: "R",
              display: "Not a Compensation Event",
              overrideResources: null,
              postActions: null
            },
            {
              id: 10,
              isActive: true,
              field: "DNG",
              display: "Decision Not Given",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "QuoteStatuses",
          values: [
            {
              id: 1,
              isActive: true,
              field: "0",
              display: "Not Accepted - $SUPPLIER_NAME to resubmit",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "1",
              display: "Accepted",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "2",
              display: "Awaiting Response",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "3",
              display: "Not Accepted - $PM_ABBREVIATION to make assessment",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: true,
              field: "4",
              display: "Not Accepted - Other quote approved",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: true,
              field: "5",
              display: "Not Accepted - Decision will not be given",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              isActive: true,
              field: "none",
              display: "Not Communicated",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "QuoteRfqImpactOpts",
          values: [
            {
              id: 1,
              isActive: true,
              field: "noeffect",
              display: "There is no effect on the Accepted Programme",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "mitigated",
              display: "There is an effect on the Accepted Programme but this has been mitigated by measures as detailed",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "notmitigated",
              display: "There is an effect on the Accepted Programme which we are unable to mitigate",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "RfqReplyProceedEnabled",
          values: [
            {
              id: 1,
              isActive: true,
              field: "RfqReplyProceedEnabled",
              display: "RFQ Quote Reply field proceed options Enabled/Disabled",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "QuoteFields",
          values: [
            {
              id: 1,
              isActive: true,
              field: "Description",
              display: "Description of the goods in the batch",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "ItemsList",
              display: "Total quantity",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "TotalListPrice",
              display: "Total price",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: false,
              field: "TotalAssessed",
              display: "Assessed list total",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: true,
              field: "TotalPrice",
              display: "Total of prices",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: true,
              field: "StartDate",
              display: "Start date",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              isActive: true,
              field: "CompletionDate",
              display: "Delivery date",
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              isActive: false,
              field: "DelayAmount",
              display: "Amount of delay damages for the late completion of the task",
              overrideResources: null,
              postActions: null
            },
            {
              id: 9,
              isActive: false,
              field: "DelayPaymentPeriod",
              display: "Payment period",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "UserLimitCheckEnabled",
          values: [
            {
              id: 1,
              isActive: false,
              field: "UserLimitCheckEnabled",
              display: "Active-Inactive state indicates weather the user limit check can be applied in Task Order communications",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ActionReminders",
          values: [
            {
              id: 1,
              isActive: true,
              field: "PmRfqAQ",
              display: "$WF_62_TITLE awaiting quotation",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "PmRfqARQ",
              display: "$WF_62_TITLE awaiting revised quotation",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "PmRfqAPMRQ",
              display: "$WF_38_NOTIFICATION_NAME quotations awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "PmRfqAPMA",
              display: "Awaiting $WF_62_NOTIFICATION_NAME",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: true,
              field: "replydraftpmcequotessupplier",
              display: "$WF_38_NOTIFICATION_NAME quotation reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: true,
              field: "draftconrfqquotation",
              display: "$WF_38_NOTIFICATION_NAME quotation",
              overrideResources: null,
              postActions: null
            }
          ]
        }
      ]
    },
    {
      id: 103,
      title: "Compensation Events",
      workflows: [
        {
          id: 6,
          title: "$PM_NAME Proposed Instructions",
          notificationName: "Proposed Instruction",
          abbreviation: "$PM_ABBREVIATION-PROP-",
          notify: true,
          financialLimitEnabled: false,
          assetFieldsEnabled: false,
          notifyingParty: "PM",
          quotingParty: "SUPPLIER",
          quoteReplyingParty: "PM",
          quoteNotificationName: "Quote",
          quoteReferencePrefix: "Quote-",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
              communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            quoteMainNotice: {
              createQuoteFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              communicateQuoteFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            quoteReplyNotice: {
              saveQuoteDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              communicateQuoteReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"]]"
          }
        },
        {
          id: 7,
          title: "$SUPPLIER_NAME Compensation Events",
          notificationName: "Compensation Event",
          abbreviation: "$SUPPLIER_ABBREVIATION-CEN-",
          notify: true,
          replyEnabled: true,
          financialLimitEnabled: false,
          assetFieldsEnabled: false,
          replyPeriodOption: "VARIATION_RESPONSE",
          replyPeriod: 0,
          notifyingParty: "SUPPLIER",
          replyingParty: "PM",
          quotingParty: "SUPPLIER",
          quoteReplyingParty: "PM",
          quoteNotificationName: "Quote",
          quoteReferencePrefix: "Quote-",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          replyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
              communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            replyNotice: {
              saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
            },
            quoteMainNotice: {
              createQuoteFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              communicateQuoteFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            quoteReplyNotice: {
              saveQuoteDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              communicateQuoteReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
          }
        },
        {
          id: 8,
          title: "$PM_NAME CE Assessments",
          notificationName: "Assessment of Compensation Event",
          abbreviation: "$PM_ABBREVIATION-CE-Assessment-",
          notify: true,
          financialLimitEnabled: false,
          assetFieldsEnabled: false,
          notifyingParty: "PM",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
              communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
          }
        },
        {
          id: 11,
          title: "Master Quote Register",
          overrideResources: null,
          userFilters: {
            accessFilter: "null"
          }
        },
        {
          id: 12,
          title: "Master CE Register",
          overrideResources: null,
          userFilters: {
            accessFilter: "null"
          }
        },
        {
          id: 13,
          title: "Implemented CE Register",
          overrideResources: null,
          userFilters: {
            accessFilter: "null"
          }
        }
      ],
      placeholders: [
        {
          replacementKey: "Resources",
          values: [
            {
              id: 1,
              isActive: true,
              field: "PmAssumptionLabel",
              display: "The quotation is to be based on the following assumptions",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "PmAssumptionNote",
              display: "You are instructed to provide a quotation by $date.",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "SupplierDescNote",
              display: "You are notified of the following event as a compensation event",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "ReplyAcceptedCommentLabel",
              display: "You are notified of the $PM_NAME's decision that the event notified is a compensation event",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: true,
              field: "ReplyRejectedCommentLabel",
              display: "Details",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: true,
              field: "ReplyAcceptedAssumptionLabel",
              display: "The quotation is to be based on the following assumptions",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              isActive: true,
              field: "QuoteNote",
              display: "We submit our quotation for compensation event $reference",
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              isActive: true,
              field: "ExtensionPMLabel",
              display: "We require an extension to the time to reply as follows",
              overrideResources: null,
              postActions: null
            },
            {
              id: 9,
              isActive: true,
              field: "ExtensionSupplierLabel",
              display: "We require an extension to the time to reply as follows",
              overrideResources: null,
              postActions: null
            },
            {
              id: 10,
              isActive: true,
              field: "AssessmentDetailLabel",
              display: "Details",
              overrideResources: null,
              postActions: null
            },
            {
              id: 11,
              isActive: true,
              field: "ProposedInstructionNote",
              display: "You are instructed to provide a quotation by $date.",
              overrideResources: null,
              postActions: null
            },
            {
              id: 12,
              isActive: true,
              field: "ProposedInstructionLabel",
              display: "The quotation is to be based on the following assumptions",
              overrideResources: null,
              postActions: null
            },
            {
              id: 13,
              isActive: true,
              field: "ReplyRejectedOptionsLabel",
              display: "You are notified of the $PM_NAME's decision that the event notified is not a compensation event as it",
              overrideResources: null,
              postActions: null
            },
            {
              id: 14,
              isActive: true,
              field: "QuoteCostEffectLabel",
              display: "Change to the Prices",
              overrideResources: null,
              postActions: null
            },
            {
              id: 15,
              isActive: true,
              field: "QuoteDateEffectLabel",
              display: "Delay",
              overrideResources: null,
              postActions: null
            },
            {
              id: 16,
              isActive: true,
              field: "QuoteDaysEffectLabel",
              display: "The length of time that the $COMPLETION_DATE is delayed",
              overrideResources: null,
              postActions: null
            },
            {
              id: 17,
              isActive: true,
              field: "AssessmentCostEffectLabel",
              display: "Change in the Total of the Prices",
              overrideResources: null,
              postActions: null
            },
            {
              id: 18,
              isActive: true,
              field: "AssessmentDaysEffectLabel",
              display: "The length of time that the $COMPLETION_DATE is delayed",
              overrideResources: null,
              postActions: null
            },
            {
              id: 19,
              isActive: true,
              field: "QuoteProgrammeAttachLabel",
              display: "Are you attaching a programme or plan showing the effect against the last programme or plan with this quotation?",
              overrideResources: null,
              postActions: null
            },
            {
              id: 20,
              isActive: true,
              field: "QuoteNoteProposedInstruction",
              display: "We submit our quotation for proposed compensation event $reference",
              overrideResources: null,
              postActions: null
            },
            {
              id: 21,
              isActive: true,
              field: "ReplyAcceptedAssumptionNote",
              display: "You are instructed to submit a quotation by $date",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "CompensationClauses",
          values: [
            {
              id: 29,
              isActive: true,
              field: "",
              display: "(1) The $PM_NAME gives an instruction changing the Goods Information unless the change is in order to make a Defect acceptable.",
              overrideResources: null,
              postActions: null
            },
            {
              id: 30,
              isActive: true,
              field: "",
              display: "(2) The $PM_NAME gives an instruction changing the Delivery Date.",
              overrideResources: null,
              postActions: null
            },
            {
              id: 31,
              isActive: true,
              field: "",
              display: "(3) The $PM_NAME does not allow access to and use of the premises as necessary for the work included in this contract.",
              overrideResources: null,
              postActions: null
            },
            {
              id: 32,
              isActive: true,
              field: "",
              display: "(4) The $PM_NAME does not provide services and other things which he is to provide as stated in this contract.",
              overrideResources: null,
              postActions: null
            },
            {
              id: 33,
              isActive: true,
              field: "",
              display: "(5) The $PM_NAME gives an instruction to stop or not to start any work.",
              overrideResources: null,
              postActions: null
            },
            {
              id: 34,
              isActive: true,
              field: "",
              display: "(6) The $PM_NAME does not reply to a communication from the $SUPPLIER_NAME within the period required by this contract.",
              overrideResources: null,
              postActions: null
            },
            {
              id: 35,
              isActive: true,
              field: "",
              display: "(7) The $PM_NAME changes a decision which he has previously communicated to the $SUPPLIER_NAME.",
              overrideResources: null,
              postActions: null
            },
            {
              id: 36,
              isActive: true,
              field: "",
              display: "(8) An event which is a $PM_NAME's risk stated in this contract.",
              overrideResources: null,
              postActions: null
            },
            {
              id: 25,
              isActive: true,
              field: "",
              display: "23.1 An item of goods required by the Batch Order is not included in the Price Schedule.",
              overrideResources: null,
              postActions: null
            },
            {
              id: 26,
              isActive: true,
              field: "",
              display: "23.1 The total quantity of goods in the Batch Orders issued under this contract is different from that stated in the Price Schedule.",
              overrideResources: null,
              postActions: null
            },
            {
              id: 27,
              isActive: true,
              field: "",
              display: "23.1 The quantity of goods stated in a Batch Order is not within the range stated in the Contract Data.",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ReplyRejectOptions",
          values: [
            {
              id: 1,
              isActive: true,
              field: "faultpscp",
              display: "arises from a fault of the $SUPPLIER_NAME",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "notexpectnothappen",
              display: "has not happened and is not expected to happen",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "noteffectcostcompletion",
              display: "has no effect on Defined Cost or upon Delivery",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "statedcontract",
              display: "is not one of the compensation events stated in this contract",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "InstructionReplyProceedOpts",
          values: [
            {
              id: 1,
              isActive: true,
              field: "61.1",
              display: "$SUPPLIER_NAME is instructed to proceed with works",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "61.2",
              display: "$SUPPLIER_NAME is instructed to NOT proceed with works",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "QuoteProgrammeImpactOpts",
          values: [
            {
              id: 1,
              isActive: true,
              field: "noeffect",
              display: "There is no effect on the Programme or Delivery Date",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "mitigated",
              display: "There is an effect on the Programme or Delivery Date but this has been mitigated by measures as detailed",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "notmitigated",
              display: "There is an effect on the Programme or Delivery Date which we are unable to mitigate",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "TaskOrderOptionEnabled",
          values: [
            {
              id: 1,
              isActive: true,
              field: "TaskOrderOptionEnabled",
              display: "Active-Inactive state indicates weather Task-Order can be selected in CEN communications",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "Fields",
          values: [
            {
              id: 1,
              isActive: false,
              field: "Assumption",
              display: "The quotation is to be based on the following assumptions",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "EWRelationEnabled",
          values: [
            {
              id: 1,
              isActive: true,
              field: "EWRelationEnabled",
              display: "Active-Inactive state indicates weather the EWN can be attached in CEN communications",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ProposedInstructionClauses",
          values: []
        },
        {
          replacementKey: "CompensationStatuses",
          values: [
            {
              id: 1,
              isActive: true,
              field: "APMA",
              display: "Quote Not Accepted - $PM_ABBREVIATION to make own Assessment",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "ARQ",
              display: "Quote Not Accepted - $SUPPLIER_NAME to resubmit",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "AM",
              display: "$PM_ABBREVIATION Assessment Made",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "QA",
              display: "Quote Accepted",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: true,
              field: "APMRQ",
              display: "Awaiting $PM_ABBREVIATION Response to quote",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: true,
              field: "APMR",
              display: "Awaiting $PM_ABBREVIATION Response to CEN",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              isActive: true,
              field: "AQ",
              display: "Awaiting Quote",
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              isActive: true,
              field: "NC",
              display: "Not Communicated",
              overrideResources: null,
              postActions: null
            },
            {
              id: 9,
              isActive: true,
              field: "R",
              display: "Not a Compensation Event",
              overrideResources: null,
              postActions: null
            },
            {
              id: 10,
              isActive: true,
              field: "DNG",
              display: "Proposed instruction will not be given",
              overrideResources: null,
              postActions: null
            },
            {
              id: 11,
              isActive: true,
              field: "ADAQ",
              display: "Awaiting Deemed Acceptance of Quote",
              overrideResources: null,
              postActions: null
            },
            {
              id: 12,
              isActive: true,
              field: "DA",
              display: "Deemed Accepted",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "QuoteStatuses",
          values: [
            {
              id: 1,
              isActive: true,
              field: "0",
              display: "Not Accepted - $SUPPLIER_NAME to resubmit",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "1",
              display: "Accepted",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "2",
              display: "Awaiting Response",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "3",
              display: "Not Accepted - $PM_ABBREVIATION to make assessment",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: true,
              field: "4",
              display: "Not Accepted - Other quote approved",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: true,
              field: "5",
              display: "Not Accepted - Proposed instruction will not be given",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              isActive: true,
              field: "6",
              display: "Awaiting Deemed Acceptance",
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              isActive: true,
              field: "7",
              display: "Deemed Accepted",
              overrideResources: null,
              postActions: null
            },
            {
              id: 9,
              isActive: true,
              field: "none",
              display: "Not Communicated",
              overrideResources: null,
              postActions: null
            },
            {
              id: 10,
              isActive: true,
              field: "8",
              display: "Acknowledged",
              overrideResources: null,
              postActions: null
            },
            {
              id: 11,
              isActive: true,
              field: "9",
              display: "Not Accepted - Process ended",
              overrideResources: null,
              postActions: null
            },
            {
              id: 12,
              isActive: true,
              field: "10",
              display: "Assessed",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "RelatedCompensationText",
          values: [
            {
              id: 1,
              isActive: true,
              field: "RelatedCompensationText",
              display: "Regarding the aforementioned instruction, you are hereby notified of a compensation event under clause 61.1",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ActionReminders",
          values: [
            {
              id: 1,
              isActive: true,
              field: "PmCompensationAQ",
              display: "$WF_5_TITLE awaiting quotation",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "PmCompensationARQ",
              display: "$WF_5_TITLE awaiting revised quotation",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "PmCompensationAPMRQ",
              display: "$WF_5_TITLE awaiting reply to quotation",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "PmCompensationAPMA",
              display: "$WF_5_TITLE awaiting assessment",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: true,
              field: "SupCompensationAQ",
              display: "$WF_7_TITLE awaiting quotation",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: true,
              field: "SupCompensationARQ",
              display: "$WF_7_TITLE awaiting revised quotation",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              isActive: true,
              field: "SupCompensationAPMR",
              display: "$WF_7_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              isActive: true,
              field: "SupCompensationAPMRQ",
              display: "$WF_7_TITLE awaiting reply to quotation",
              overrideResources: null,
              postActions: null
            },
            {
              id: 9,
              isActive: true,
              field: "SupCompensationAPMA",
              display: "$WF_7_TITLE awaiting assessment",
              overrideResources: null,
              postActions: null
            },
            {
              id: 10,
              isActive: true,
              field: "PmProposedAQ",
              display: "$WF_6_TITLE awaiting quotation",
              overrideResources: null,
              postActions: null
            },
            {
              id: 11,
              isActive: true,
              field: "PmProposedARQ",
              display: "$WF_6_TITLE awaiting revised quotation",
              overrideResources: null,
              postActions: null
            },
            {
              id: 12,
              isActive: true,
              field: "PmProposedAPMRQ",
              display: "$WF_6_TITLE awaiting reply to quotation",
              overrideResources: null,
              postActions: null
            },
            {
              id: 13,
              isActive: true,
              field: "PmProposedAPMA",
              display: "$WF_6_TITLE awaiting assessment",
              overrideResources: null,
              postActions: null
            },
            {
              id: 15,
              isActive: true,
              field: "SupAssumption",
              display: "$WF_42_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 21,
              isActive: true,
              field: "SupClaimAPMR",
              display: "$WF_37_TITLE awaiting reply to notice",
              overrideResources: null,
              postActions: null
            },
            {
              id: 16,
              isActive: true,
              field: "SupClaimAQ",
              display: "$WF_37_TITLE awaiting quotation",
              overrideResources: null,
              postActions: null
            },
            {
              id: 17,
              isActive: true,
              field: "SupClaimARQ",
              display: "$WF_37_TITLE awaiting revised quotation",
              overrideResources: null,
              postActions: null
            },
            {
              id: 19,
              isActive: true,
              field: "SupClaimAPMRQ",
              display: "$WF_37_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 20,
              isActive: true,
              field: "SupClaimAPMA",
              display: "$WF_37_TITLE awaiting determination",
              overrideResources: null,
              postActions: null
            },
            {
              id: 22,
              isActive: true,
              field: "replydraftpmcequotessupplier",
              display: "$WF_7_TITLE quotations",
              overrideResources: null,
              postActions: null
            },
            {
              id: 25,
              isActive: true,
              field: "COMPENSATION_CWN_APMR",
              display: "$WF_67_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 23,
              isActive: true,
              field: "COMPENSATION_CWN_AQ",
              display: "$WF_67_TITLE awaiting reply awaiting full details",
              overrideResources: null,
              postActions: null
            },
            {
              id: 24,
              isActive: true,
              field: "COMPENSATION_CWN_ARQ",
              display: "$WF_67_TITLE awaiting reply awaiting revised details",
              overrideResources: null,
              postActions: null
            },
            {
              id: 26,
              isActive: true,
              field: "COMPENSATION_CWN_APMRQ",
              display: "$WF_67_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 27,
              isActive: true,
              field: "COMPENSATION_CWN_APMA",
              display: "$WF_67_TITLE awaiting determination",
              overrideResources: null,
              postActions: null
            },
            {
              id: 28,
              isActive: true,
              field: "COMPENSATION_CLIENTCWN_AQ",
              display: "$WF_75_TITLE awaiting full details",
              overrideResources: null,
              postActions: null
            },
            {
              id: 29,
              isActive: true,
              field: "COMPENSATION_CLIENTCWN_ARQ",
              display: "$WF_75_TITLE awaiting revised details",
              overrideResources: null,
              postActions: null
            },
            {
              id: 30,
              isActive: true,
              field: "COMPENSATION_CLIENTCWN_APMR",
              display: "$WF_75_TITLE awaiting reply to notice",
              overrideResources: null,
              postActions: null
            },
            {
              id: 31,
              isActive: true,
              field: "COMPENSATION_CLIENTCWN_APMRQ",
              display: "$WF_75_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 32,
              isActive: true,
              field: "COMPENSATION_CLIENTCWN_APMA",
              display: "$WF_75_TITLE awaiting determination",
              overrideResources: null,
              postActions: null
            },
            {
              id: 33,
              isActive: true,
              field: "COMPENSATION_CLIENT_AQ",
              display: "$WF_76_TITLE awaiting quotation",
              overrideResources: null,
              postActions: null
            },
            {
              id: 34,
              isActive: true,
              field: "COMPENSATION_CLIENT_ARQ",
              display: "$WF_76_TITLE awaiting revised quotation",
              overrideResources: null,
              postActions: null
            },
            {
              id: 35,
              isActive: true,
              field: "COMPENSATION_CLIENT_APMR",
              display: "$WF_76_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 36,
              isActive: true,
              field: "COMPENSATION_CLIENT_APMRQ",
              display: "$WF_76_TITLE awaiting reply to quotation",
              overrideResources: null,
              postActions: null
            },
            {
              id: 37,
              isActive: true,
              field: "COMPENSATION_CLIENT_APMA",
              display: "$WF_76_TITLE awaiting assessment",
              overrideResources: null,
              postActions: null
            },
            {
              id: 14,
              isActive: true,
              field: "PmExtension",
              display: "$WF_9_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 38,
              isActive: true,
              field: "SupExtension",
              display: "$WF_10_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "CompensationEventsAcceptanceOptions",
          values: [
            {
              id: 1,
              isActive: true,
              field: "1",
              display: "Is a compensation event",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "0",
              display: "Is not a compensation event",
              overrideResources: null,
              postActions: null
            }
          ]
        }
      ]
    },
    {
      id: 104,
      title: "Programmes",
      workflows: [
        {
          id: 14,
          title: "$SUPPLIER_NAME Programme",
          notificationName: "Programme",
          abbreviation: "$SUPPLIER_ABBREVIATION-Prog-",
          notify: true,
          replyEnabled: true,
          assetFieldsEnabled: false,
          replyPeriodOption: "PROGRAMME_REPLY_PERIOD",
          replyPeriod: 0,
          resubmitPeriodOption: "SUPPLIER_REPLY_PERIOD",
          resubmitPeriod: 0,
          notifyingParty: "SUPPLIER",
          replyingParty: "PM",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          replyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
              communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            replyNotice: {
              saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Support\"],\"or\",[\"rolepermissions\",\"=\",\"Manager\"]]]",
              communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
          }
        }
      ],
      placeholders: [
        {
          replacementKey: "Resources",
          values: [
            {
              id: 1,
              isActive: true,
              field: "ReasonLabel",
              display: "Reason for any changes",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "ChangeLabel",
              display: "Change in any other important milestone in period and reasons why",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "MainProgressLabel",
              display: "Main progress achieved in period",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "KeyActivitiesLabel",
              display: "Key activities forecast before the next submission",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: true,
              field: "SummaryLabel",
              display: "Summary of critical path",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: true,
              field: "ChangesLabel",
              display: "Main changes made in period",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              isActive: true,
              field: "CompensationLabel",
              display: "Compensation events added this period",
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              isActive: true,
              field: "NotificationClause",
              display: "Please find attached Programme for acceptance",
              overrideResources: null,
              postActions: null
            },
            {
              id: 9,
              isActive: true,
              field: "ReplyRejectReasonLabel",
              display: "The $SUPPLIER_NAME’s Programme is not accepted for the following reasons",
              overrideResources: null,
              postActions: null
            },
            {
              id: 10,
              isActive: true,
              field: "ReplyNotificationClause",
              display: "In accordance with the conditions of contract you are notified that the $SUPPLIER_NAME’s Programme",
              overrideResources: null,
              postActions: null
            },
            {
              id: 11,
              isActive: true,
              field: "ReplyNotificationClause",
              display: "You are notified that the $SUPPLIER_NAME’s Programme",
              overrideResources: null,
              postActions: null
            },
            {
              id: 12,
              isActive: true,
              field: "ReferenceLabel",
              display: "Programme Reference",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ReplyRejectOptions",
          values: [
            {
              id: 1,
              isActive: true,
              field: "plansnotpractical",
              display: "The $SUPPLIER_NAME’s plans which it shows are not practical",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "missingcontractrequires",
              display: "It does not show the information which this contract requires",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "notrepresentplan",
              display: "It does not represent the $SUPPLIER_NAME’s plans realistically",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "notcomply",
              display: "It does not comply with the Scope",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "DashboardDisplayPlannedCompletionOnLatest",
          values: [
            {
              id: 1,
              isActive: false,
              field: "DashboardDisplayPlannedCompletionOnLatest",
              display: "Active-Inactive state indicates weather (Planned Completion shown on the latest Accepted Programme) is displayed on dasboard",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "Fields",
          values: [
            {
              id: 1,
              isActive: false,
              field: "PreviousPlanned",
              display: "Previous Planned Completion",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: false,
              field: "PlannedCompletion",
              display: "Date of Planned Completion this period",
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              isActive: false,
              field: "Changes",
              display: "Main changes made in period",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "Reason",
              display: "Reason for any changes since last period",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: false,
              field: "Change",
              display: "Change in any other important project milestone in period and reasons why",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: true,
              field: "MainProgress",
              display: "Main progress achieved in period",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: false,
              field: "KeyActivities",
              display: "Key activities forecast in next reporting period",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              isActive: false,
              field: "Summary",
              display: "Summary of critical path",
              overrideResources: null,
              postActions: null
            },
            {
              id: 9,
              isActive: false,
              field: "Compensation",
              display: "Compensation events added to programme this period",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "UnifiedReplyOptions",
          values: [
            {
              id: 1,
              wfid: 14,
              isActive: true,
              field: "ACCEPT",
              display: "Accepted",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              wfid: 14,
              isActive: false,
              field: "ACCEPT_WITH_COMMENTS",
              display: "Accepted with comments",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              wfid: 14,
              isActive: true,
              field: "NOT_ACCEPTED",
              display: "Not accepted",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              wfid: 14,
              isActive: true,
              field: "NOT_ACCEPTED_RESUBMIT",
              display: "Not accepted - resubmission required",
              overrideResources: null,
              postActions: [
                {
                  askUser: false,
                  daysForAction: 0,
                  action: "CREATE",
                  ownerParty: "SUPPLIER",
                  actionType: "WF_14",
                  timePeriod: "SUPPLIER_REPLY_PERIOD"
                }
              ]
            },
            {
              id: 5,
              wfid: 14,
              isActive: false,
              field: "NO_REPLY_REQUIRED",
              display: "Reply not required",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ActionReminders",
          values: [
            {
              id: 1,
              isActive: true,
              field: "Supplier",
              display: "$WF_14_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            }
          ]
        }
      ]
    },
    {
      id: 105,
      title: "Notifications",
      workflows: [
        {
          id: 15,
          title: "$PM_NAME Notifications",
          notificationName: "Notification",
          abbreviation: "$PM_ABBREVIATION-Notification-",
          notify: true,
          replyEnabled: false,
          assetFieldsEnabled: false,
          replyPeriodOption: "SUPPLIER_REPLY_PERIOD",
          replyPeriod: 0,
          resubmitPeriodOption: "PM_REPLY_PERIOD",
          resubmitPeriod: 0,
          notifyingParty: "PM",
          replyingParty: "SUPPLIER",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          replyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
              communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            replyNotice: {
              saveDraftReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              communicateReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"]]"
          }
        },
        {
          id: 16,
          title: "$SUPPLIER_NAME Notifications",
          notificationName: "Notification",
          abbreviation: "$SUPPLIER_ABBREVIATION-Notification-",
          notify: true,
          replyEnabled: false,
          assetFieldsEnabled: false,
          replyPeriodOption: "PM_REPLY_PERIOD",
          replyPeriod: 0,
          resubmitPeriodOption: "SUPPLIER_REPLY_PERIOD",
          resubmitPeriod: 0,
          notifyingParty: "SUPPLIER",
          replyingParty: "PM",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          replyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
              communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            replyNotice: {
              saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"PM\"]]"
          }
        }
      ],
      placeholders: [
        {
          replacementKey: "PmClauses",
          values: [
            {
              id: 2,
              isActive: true,
              field: "",
              display: "13.1 of a change of address for communications",
              applyReplyPeriod: false,
              noReply: true,
              overrideReplyingParty: false,
              overrideResources: null,
              postActions: null
            },
            {
              id: 35,
              isActive: true,
              field: "",
              display: "23.1 of an agreement to extend or reduce the batch order interval",
              applyReplyPeriod: false,
              noReply: true,
              overrideReplyingParty: false,
              overrideResources: null,
              postActions: null
            },
            {
              id: 37,
              isActive: true,
              field: "",
              display: "85.1 of a request for insurance certificates",
              applyReplyPeriod: false,
              noReply: true,
              overrideReplyingParty: false,
              overrideResources: null,
              postActions: null
            },
            {
              id: 36,
              isActive: true,
              field: "",
              display: "85.1 of insurance certificates",
              applyReplyPeriod: false,
              noReply: true,
              overrideReplyingParty: false,
              overrideResources: null,
              postActions: null
            },
            {
              id: 30,
              isActive: true,
              field: "",
              display: "90.1 of a wish to terminate",
              applyReplyPeriod: false,
              noReply: true,
              overrideReplyingParty: false,
              overrideResources: null,
              postActions: null
            },
            {
              id: 32,
              isActive: false,
              field: "",
              display: "90.1 of a Termination Certificate",
              applyReplyPeriod: false,
              noReply: true,
              overrideReplyingParty: false,
              overrideResources: null,
              postActions: null
            },
            {
              id: 33,
              isActive: true,
              field: "",
              display: "90.3 of $SUPPLIER_NAME default",
              applyReplyPeriod: false,
              noReply: true,
              overrideReplyingParty: false,
              overrideResources: null,
              postActions: null
            },
            {
              id: 31,
              isActive: true,
              field: "",
              display: "Other notification",
              applyReplyPeriod: false,
              noReply: true,
              overrideReplyingParty: false,
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "SupplierClauses",
          values: [
            {
              id: 2,
              isActive: true,
              field: "",
              display: "13.1 of a change of address for communications",
              applyReplyPeriod: false,
              noReply: true,
              overrideReplyingParty: false,
              overrideResources: null,
              postActions: null
            },
            {
              id: 9,
              isActive: true,
              field: "",
              display: "85.1 of a request for insurance certificates",
              applyReplyPeriod: false,
              noReply: false,
              overrideReplyingParty: false,
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              isActive: true,
              field: "",
              display: "85.1 of insurance certificates",
              applyReplyPeriod: false,
              noReply: true,
              overrideReplyingParty: false,
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "",
              display: "90.1 of a wish to terminate",
              applyReplyPeriod: false,
              noReply: true,
              overrideReplyingParty: false,
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              isActive: true,
              field: "",
              display: "Other notification",
              applyReplyPeriod: false,
              noReply: true,
              overrideReplyingParty: false,
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ActionReminders",
          values: [
            {
              id: 4,
              isActive: true,
              field: "Client",
              display: "$WF_57_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "PM",
              display: "$WF_15_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "Supervisor",
              display: "$WF_16_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 1,
              isActive: true,
              field: "Supplier",
              display: "$WF_17_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: true,
              field: "PmToSupervisor",
              display: "$WF_58_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              isActive: true,
              field: "PmToClient",
              display: "$WF_59_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 12,
              isActive: true,
              field: "SupplierToSupervisor",
              display: "$WF_81_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: true,
              field: "SupervisorToPm",
              display: "$WF_60_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 9,
              isActive: true,
              field: "ClientToClient",
              display: "$WF_64_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              isActive: true,
              field: "PmToPm",
              display: "$WF_63_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 10,
              isActive: true,
              field: "SupplierToSupplier",
              display: "$WF_65_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 11,
              isActive: true,
              field: "SupervisorToSupervisor",
              display: "$WF_66_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            }
          ]
        }
      ]
    },
    {
      id: 106,
      title: "Submissions",
      workflows: [
        {
          id: 49,
          title: "$PM_NAME Submissions",
          notificationName: "Submission",
          abbreviation: "$PM_ABBREVIATION-Submission-",
          notify: true,
          replyEnabled: true,
          assetFieldsEnabled: false,
          replyPeriodOption: "SUPPLIER_REPLY_PERIOD",
          replyPeriod: 0,
          resubmitPeriodOption: "PM_REPLY_PERIOD",
          resubmitPeriod: 0,
          notifyingParty: "PM",
          replyingParty: "SUPPLIER",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          replyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
              communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            replyNotice: {
              saveDraftReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              communicateReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
          }
        },
        {
          id: 18,
          title: "$SUPPLIER_NAME Submissions",
          notificationName: "Submission",
          abbreviation: "$SUPPLIER_ABBREVIATION-Submission-",
          notify: true,
          replyEnabled: true,
          assetFieldsEnabled: false,
          replyPeriodOption: "PM_REPLY_PERIOD",
          replyPeriod: 0,
          resubmitPeriodOption: "SUPPLIER_REPLY_PERIOD",
          resubmitPeriod: 0,
          notifyingParty: "SUPPLIER",
          replyingParty: "PM",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          replyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
              communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            replyNotice: {
              saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Support\"],\"or\",[\"rolepermissions\",\"=\",\"Manager\"]]]",
              communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
          }
        }
      ],
      placeholders: [
        {
          replacementKey: "IssueClauses",
          values: [
            {
              id: 11,
              isActive: true,
              field: "",
              display: "43.1 of a proposal to accept a Defect",
              applyReplyPeriod: false,
              noReply: false,
              overrideResources: null,
              postActions: null
            },
            {
              id: 25,
              isActive: true,
              field: "",
              display: "Other submission",
              applyReplyPeriod: false,
              noReply: false,
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "IssueClausesPM",
          values: [
            {
              id: 2,
              isActive: true,
              field: "",
              display: "43.1 a proposal to accept a Defect",
              applyReplyPeriod: false,
              noReply: false,
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "",
              display: "Other submission",
              applyReplyPeriod: false,
              noReply: false,
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "UnifiedReplyOptions",
          values: [
            {
              id: 1,
              wfid: 18,
              isActive: true,
              field: "ACCEPT",
              display: "Accepted",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              wfid: 18,
              isActive: false,
              field: "ACCEPT_WITH_COMMENTS",
              display: "Accepted with comments",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              wfid: 18,
              isActive: true,
              field: "NOT_ACCEPTED",
              display: "Not accepted",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              wfid: 18,
              isActive: true,
              field: "NOT_ACCEPTED_RESUBMIT",
              display: "Not accepted - resubmission required",
              overrideResources: null,
              postActions: [
                {
                  askUser: false,
                  daysForAction: 0,
                  action: "CREATE",
                  ownerParty: "SUPPLIER",
                  actionType: "WF_18",
                  timePeriod: "SUPPLIER_REPLY_PERIOD"
                }
              ]
            },
            {
              id: 5,
              wfid: 18,
              isActive: false,
              field: "NO_REPLY_REQUIRED",
              display: "Reply not required",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              wfid: 49,
              isActive: true,
              field: "ACCEPT",
              display: "Accepted",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              wfid: 49,
              isActive: false,
              field: "ACCEPT_WITH_COMMENTS",
              display: "Accepted with comments",
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              wfid: 49,
              isActive: true,
              field: "NOT_ACCEPTED",
              display: "Not accepted",
              overrideResources: null,
              postActions: null
            },
            {
              id: 9,
              wfid: 49,
              isActive: true,
              field: "NOT_ACCEPTED_RESUBMIT",
              display: "Not accepted - resubmission required",
              overrideResources: null,
              postActions: [
                {
                  askUser: false,
                  daysForAction: 0,
                  action: "CREATE",
                  ownerParty: "PM",
                  actionType: "WF_49",
                  timePeriod: "PM_REPLY_PERIOD"
                }
              ]
            },
            {
              id: 10,
              wfid: 49,
              isActive: false,
              field: "NO_REPLY_REQUIRED",
              display: "Reply not required",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ActionReminders",
          values: [
            {
              id: 1,
              isActive: true,
              field: "Supplier",
              display: "$WF_18_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "PM",
              display: "$WF_49_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            }
          ]
        }
      ]
    },
    {
      id: 107,
      title: "$SUPPLIER_NAME Quotations for accepting a Defect",
      workflows: [
        {
          id: 19,
          title: "$SUPPLIER_NAME Submissions (wq)",
          notificationName: "Quotation to accept a Defect",
          abbreviation: "$SUPPLIER-ABBREVIATION-Defect-Quote-",
          notify: true,
          replyEnabled: true,
          financialLimitEnabled: false,
          assetFieldsEnabled: false,
          replyPeriodOption: "PM_REPLY_PERIOD",
          replyPeriod: 0,
          resubmitPeriodOption: "SUPPLIER_REPLY_PERIOD",
          resubmitPeriod: 0,
          notifyingParty: "SUPPLIER",
          replyingParty: "PM",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          replyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
              communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            replyNotice: {
              saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Support\"],\"or\",[\"rolepermissions\",\"=\",\"Manager\"]]]",
              communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
          }
        }
      ],
      placeholders: [
        {
          replacementKey: "Resources",
          values: [
            {
              id: 1,
              isActive: true,
              field: "CostEffectLabel",
              display: "Change in the Prices",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "DaysEffectLabel",
              display: "Delay to Delivery Date",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "WarningBanner",
              display: "Do not use this workflow for a Batch Order quotation.",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ProposalClauses",
          values: [
            {
              id: 2,
              isActive: true,
              field: "",
              display: "43.2 a quotation to accept a Defect",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "UserLimitCheckEnabled",
          values: [
            {
              id: 1,
              isActive: false,
              field: "UserLimitCheckEnabled",
              display: "Active-Inactive state indicates weather the user limit check can be applied in Proposal communications",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "UnifiedReplyOptions",
          values: [
            {
              id: 1,
              wfid: 19,
              isActive: true,
              field: "ACCEPT",
              display: "Accepted",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              wfid: 19,
              isActive: false,
              field: "ACCEPT_WITH_COMMENTS",
              display: "Accepted with comments",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              wfid: 19,
              isActive: true,
              field: "NOT_ACCEPTED",
              display: "Not accepted",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              wfid: 19,
              isActive: true,
              field: "NOT_ACCEPTED_RESUBMIT",
              display: "Not accepted - resubmission required",
              overrideResources: null,
              postActions: [
                {
                  askUser: false,
                  daysForAction: 0,
                  action: "CREATE",
                  ownerParty: "SUPPLIER",
                  actionType: "WF_19",
                  timePeriod: "SUPPLIER_REPLY_PERIOD"
                }
              ]
            },
            {
              id: 5,
              wfid: 19,
              isActive: false,
              field: "NO_REPLY_REQUIRED",
              display: "Reply not required",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ActionReminders",
          values: [
            {
              id: 1,
              isActive: true,
              field: "Supplier",
              display: "$WF_19_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            }
          ]
        }
      ]
    },
    {
      id: 108,
      title: "Payments",
      workflows: [
        {
          id: 21,
          title: "$SUPPLIER_NAME Payment Applications",
          notificationName: "Payment Application",
          abbreviation: "$SUPPLIER_ABBREVIATION-Payment-",
          notify: true,
          financialLimitEnabled: false,
          assetFieldsEnabled: false,
          notifyingParty: "SUPPLIER",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
              communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
          }
        },
        {
          id: 20,
          title: "$PM_NAME Payment Notifications",
          notificationName: "Payment Certificate",
          abbreviation: "$PM_ABBREVIATION-Payment-",
          notify: true,
          financialLimitEnabled: false,
          assetFieldsEnabled: false,
          notifyingParty: "PM",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
              communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
          }
        }
      ],
      placeholders: [
        {
          replacementKey: "Resources",
          values: [
            {
              id: 1,
              isActive: true,
              field: "CumulativePriceLabel",
              display: "Price for goods delivered to date",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "PlusAmountsSupplierLabel",
              display: "Plus other amounts to be paid to the $SUPPLIER_NAME",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "LessAmountsSupplierLabel",
              display: "Less amounts to be paid by or retained from the $SUPPLIER_NAME",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "TaxSupplierLabel",
              display: "Tax which the law requires the Employer to pay to the $SUPPLIER_NAME",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: true,
              field: "WarningBanner",
              display: "The Supplier assesses the amount due and, by each assessment day, applies to the Purchaser for payment. There is an assessment day in each month from the starting date until the month after the defects date.",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: true,
              field: "SummaryDetailsLabel",
              display: "Summary details",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "TaxEnabled",
          values: [
            {
              id: 1,
              isActive: true,
              field: "TaxEnabled",
              display: "Active-Inactive state indicates tax field will be included in notification forms",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ApplicationTypes",
          values: [
            {
              id: 2,
              isActive: true,
              field: "INTERIM",
              display: "50.2 application for payment",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: false,
              field: "COMPLETION",
              display: "Completion",
              overrideResources: null,
              postActions: null
            },
            {
              id: 1,
              isActive: false,
              field: "FINAL",
              display: "53.2 assessment of the final amount due",
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              isActive: false,
              field: "TERMINATION",
              display: "Termination",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: false,
              field: "SUPPLEMENTARY",
              display: "Supplementary",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: false,
              field: "DRAFT",
              display: "Draft",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: false,
              field: "EXTRA",
              display: "Extra",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              isActive: false,
              field: "OTHER",
              display: "Other",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "PaymentTypes",
          values: [
            {
              id: 2,
              isActive: true,
              field: "INTERIM",
              display: "51.1 payment certificate within three weeks of assessment date",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: false,
              field: "COMPLETION",
              display: "Completion",
              overrideResources: null,
              postActions: null
            },
            {
              id: 1,
              isActive: false,
              field: "FINAL",
              display: "53.1 final payment certificate",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: false,
              field: "SUPPLEMENTARY",
              display: "Supplementary",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              isActive: false,
              field: "DRAFT",
              display: "Draft",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: false,
              field: "EXTRA",
              display: "Extra",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: false,
              field: "OTHER",
              display: "Other",
              overrideResources: null,
              postActions: null
            }
          ]
        }
      ]
    },
    {
      id: 117,
      title: "Other Certificates",
      workflows: [
        {
          id: 68,
          title: "$PM_NAME Certificates",
          notificationName: "Certificate",
          abbreviation: "$PM_ABBREVIATION-Certificate-",
          notify: true,
          replyEnabled: false,
          assetFieldsEnabled: false,
          replyPeriodOption: "SUPPLIER_REPLY_PERIOD",
          replyPeriod: 0,
          resubmitPeriodOption: "PM_REPLY_PERIOD",
          resubmitPeriod: 0,
          notifyingParty: "PM",
          replyingParty: "SUPPLIER",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          replyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
              communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            replyNotice: {
              saveDraftReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Cost Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              communicateReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
          }
        }
      ],
      placeholders: [
        {
          replacementKey: "Resources",
          values: [
            {
              id: 1,
              isActive: true,
              field: "PmCertificateText",
              display: "",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "SupplierCertificateText",
              display: "",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "ClientCertificateText",
              display: "",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "SupervisorCertificateText",
              display: "",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "CompletionFields",
          values: [
            {
              id: 1,
              isActive: true,
              field: "CertifiedDate",
              display: "Completion Date",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "Description",
              display: "Details",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "Works",
              display: "Outstanding Works",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "Defects",
              display: "Defects",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "SectionalCompletionFields",
          values: [
            {
              id: 1,
              isActive: true,
              field: "CertifiedDate",
              display: "Sectional Completion Date",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "Description",
              display: "Details",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "Works",
              display: "Outstanding Works",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "Defects",
              display: "Defects",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "TakingOverFields",
          values: [
            {
              id: 1,
              isActive: true,
              field: "CertifiedDate",
              display: "Taking Over Date",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "Description",
              display: "Details",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "Works",
              display: "Outstanding Works",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "Defects",
              display: "Defects",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "DefectsFields",
          values: [
            {
              id: 1,
              isActive: true,
              field: "CertifiedDate",
              display: "Certified Date",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "Description",
              display: "Details",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: false,
              field: "Works",
              display: "Outstanding Works",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "Defects",
              display: "Outstanding Defects",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "TerminationFields",
          values: [
            {
              id: 1,
              isActive: true,
              field: "CertifiedDate",
              display: "Certified Date",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "Description",
              display: "Details",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: false,
              field: "Works",
              display: "Outstanding Works",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: false,
              field: "Defects",
              display: "Outstanding Defects",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "OtherFields",
          values: [
            {
              id: 1,
              isActive: true,
              field: "CertifiedDate",
              display: "Certified Date",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "Description",
              display: "Details",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: false,
              field: "Works",
              display: "Outstanding Works",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: false,
              field: "Defects",
              display: "Outstanding Defects",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "TaskOrderCompletionFields",
          values: [
            {
              id: 1,
              isActive: true,
              field: "CertifiedDate",
              display: "Certified Date",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "Description",
              display: "Details",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: false,
              field: "Works",
              display: "Outstanding Works",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: false,
              field: "Defects",
              display: "Outstanding Defects",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ProjectOrderCompletionFields",
          values: [
            {
              id: 1,
              isActive: true,
              field: "CertifiedDate",
              display: "Certified Date",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "Description",
              display: "Details",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: false,
              field: "Works",
              display: "Outstanding Works",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: false,
              field: "Defects",
              display: "Outstanding Defects",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ReplyOptions",
          values: [
            {
              id: 1,
              isActive: true,
              field: "Accepted",
              display: "Accepted",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "Not Accepted",
              display: "Not Accepted",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "PMCertTypes",
          values: [
            {
              id: 1,
              isActive: false,
              field: "",
              display: "30.2 Completion Certificate",
              effect: "COMPLETION",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: false,
              field: "",
              display: "X5 30.2 Sectional Completion Certificate",
              effect: "SECTIONAL_COMPLETION",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: false,
              field: "",
              display: "35.3 Taking Over Certificate",
              effect: "TAKING_OVER",
              overrideResources: null,
              postActions: null
            },
            {
              id: 9,
              isActive: false,
              field: "",
              display: "43.3 Defects Certificate (NEC3 ECC)",
              effect: "DEFECTS",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: false,
              field: "",
              display: "44.3 Defects Certificate",
              effect: "DEFECTS",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: true,
              field: "",
              display: "90.1 Termination Certificate",
              effect: "TERMINATION",
              overrideResources: null,
              postActions: null
            },
            {
              id: 10,
              isActive: false,
              field: "",
              display: "X19.1 Termination Certificate (NEC4 TSC)",
              effect: "TERMINATION",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: false,
              field: "",
              display: "Other Certificate",
              effect: "OTHER",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              isActive: false,
              field: "",
              display: "Task Order Completion",
              effect: "TASK_ORDER_COMPLETION",
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              isActive: false,
              field: "",
              display: "Project Order Completion",
              effect: "PROJECT_ORDER_COMPLETION",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "CompletionChangesStateEnabled",
          values: [
            {
              id: 1,
              isActive: true,
              field: "CompletionChangesStateEnabled",
              display: "Indicate whether communication of a Completion Certificate should change the contract state",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ActionReminders",
          values: [
            {
              id: 1,
              isActive: true,
              field: "PM",
              display: "$WF_68_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "Supplier",
              display: "$WF_69_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "Client",
              display: "$WF_70_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "Supervisor",
              display: "$WF_71_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            }
          ]
        }
      ]
    },
    {
      id: 109,
      title: "Defects",
      workflows: [
        {
          id: 23,
          title: "$PM_NAME Defect Notifications",
          notificationName: "Defect Notification",
          pageTitle: "$PM_NAME Defect Notification",
          abbreviation: "Defect-",
          notify: true,
          assetFieldsEnabled: false,
          notifyingParty: "PM",
          actioningParty: "PM",
          resolveActioningParty: "PM",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
              communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            actionTab: {
              actionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]",
            resolveActionTab: {
              resolveActionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            }
          }
        },
        {
          id: 26,
          title: "Master Defect Register",
          notificationName: "Defect Notification",
          abbreviation: "Defect",
          overrideResources: null,
          userFilters: {
            accessFilter: "null"
          }
        }
      ],
      placeholders: [
        {
          replacementKey: "Resources",
          values: [
            {
              id: 1,
              isActive: true,
              field: "InstructionClauseLabel",
              display: "You are instructed to search for a Defect as follows",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "SupervisorClauseLabel",
              display: "You are notified of the following Defect",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "SupplierClauseLabel",
              display: "You are notified of the following Defect",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "TestsClauseLabel",
              display: "You are notified of the following test or inspection",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: true,
              field: "DefectsWarningBanner",
              display: "A Defect is not notified after the end of the service period.",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "UnifiedClauses",
          values: [
            {
              id: 3,
              wfid: 22,
              isActive: false,
              field: "",
              display: "43.1 Instruction to search for a Defect",
              overrideResources: null,
              postActions: [
                {
                  askUser: false,
                  daysForAction: 0,
                  action: "CREATE",
                  ownerParty: "SUPPLIER",
                  actionType: "WF_24",
                  timePeriod: "SUPPLIER_REPLY_PERIOD"
                }
              ]
            },
            {
              id: 1,
              wfid: 23,
              isActive: true,
              field: "",
              display: "41.1 Notification of a Defect",
              overrideResources: null,
              postActions: []
            },
            {
              id: 2,
              wfid: 24,
              isActive: false,
              field: "",
              display: "43.2 Notification of a Defect",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ActionReminders",
          values: [
            {
              id: 1,
              isActive: true,
              field: "Instruction",
              display: "$WF_22_TITLE awaiting closure",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "SuperDefect",
              display: "$WF_23_TITLE awaiting closure",
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              isActive: true,
              field: "SupplierDefect",
              display: "$WF_24_TITLE awaiting closure",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "Inspection",
              display: "$WF_25_TITLE awaiting closure",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "SupervisorTestAndInspection",
              display: "$WF_47_TITLE awaiting closure",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: true,
              field: "PMTestAndInspection",
              display: "$WF_48_TITLE awaiting closure",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: true,
              field: "PMNCProposal",
              display: "$WF_54_TITLE awaiting acceptance",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              isActive: true,
              field: "NonConformity",
              display: "$WF_55_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ClosureReasonOptions",
          values: [
            {
              id: 1,
              isActive: true,
              field: "Accepted",
              display: "Accepted",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "Corrected",
              display: "Corrected",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "No Defect",
              display: "Not a Defect",
              overrideResources: null,
              postActions: null
            }
          ]
        }
      ]
    },
    {
      id: 110,
      title: "Delegated Actions",
      workflows: [
        {
          id: 27,
          title: "$PM_NAME Delegated Actions",
          notificationName: "Delegated Action",
          abbreviation: "$PM_ABBREVIATION-Action-",
          notify: true,
          assetFieldsEnabled: false,
          notifyingParty: "PM",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
              communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
          }
        }
      ],
      placeholders: [
        {
          replacementKey: "Resources",
          values: [
            {
              id: 1,
              isActive: true,
              field: "DelegationClause",
              display: "You are notified of the following delegation of the $PM_NAME's actions under clause 14.5",
              overrideResources: null,
              postActions: null
            }
          ]
        }
      ]
    },
    {
      id: 111,
      title: "Records",
      workflows: [
        {
          id: 30,
          title: "$PM_NAME Meetings",
          notificationName: "Meeting",
          abbreviation: "$PM_ABBREVIATION-Meeting-",
          notify: true,
          assetFieldsEnabled: false,
          notifyingParty: "PM",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
              communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
          }
        },
        {
          id: 31,
          title: "$SUPPLIER_NAME Meetings",
          notificationName: "Meeting",
          abbreviation: "$SUPPLIER_ABBREVIATION-Meeting-",
          notify: true,
          assetFieldsEnabled: false,
          notifyingParty: "SUPPLIER",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
              communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
          }
        },
        {
          id: 32,
          title: "$SUPPLIER_NAME Site Diary",
          notificationName: "Site Diary",
          abbreviation: "Diary-",
          notify: true,
          assetFieldsEnabled: false,
          notifyingParty: "SUPPLIER",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
              communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
          }
        },
        {
          id: 33,
          title: "Weather",
          notificationName: "Weather",
          abbreviation: "Weather-",
          notify: true,
          assetFieldsEnabled: false,
          notifyingParty: "SUPPLIER",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
              communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
          }
        }
      ],
      placeholders: [
        {
          replacementKey: "Resources",
          values: []
        },
        {
          replacementKey: "ActionReminders",
          values: []
        }
      ]
    },
    {
      id: 112,
      title: "RFI's / TQ's",
      workflows: [
        {
          id: 34,
          title: "$SUPPLIER_NAME RFI's / TQ's",
          notificationName: "RFI / TQ",
          abbreviation: "RFI_TQ-",
          notify: true,
          replyEnabled: true,
          assetFieldsEnabled: false,
          replyPeriodOption: "ASKED_ON_COMMUNICATION_FORM",
          replyPeriod: 0,
          notifyingParty: "SUPPLIER",
          replyingParty: "PM",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          replyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
              communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            replyNotice: {
              saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Cost Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"PM\"]]"
          }
        },
        {
          id: 80,
          title: "$PM_NAME RFI's / TQ's",
          notificationName: "RFI / TQ",
          abbreviation: "$PM_ABBREVIATION-RFI_TQ-",
          notify: true,
          replyEnabled: true,
          assetFieldsEnabled: false,
          replyPeriodOption: "ASKED_ON_COMMUNICATION_FORM",
          replyPeriod: 0,
          notifyingParty: "PM",
          replyingParty: "SUPPLIER",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          replyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
              communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            replyNotice: {
              saveDraftReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Cost Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              communicateReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"]]"
          }
        },
        {
          id: 82,
          title: "Master RFI / TQ Register",
          notificationName: "RFI / TQ",
          abbreviation: "RFI/TQ-",
          overrideResources: null,
          userFilters: {
            accessFilter: "null"
          }
        }
      ],
      placeholders: [
        {
          replacementKey: "Resources",
          values: []
        },
        {
          replacementKey: "ActionReminders",
          values: [
            {
              id: 1,
              isActive: true,
              field: "Supplier",
              display: "$WF_34_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "PM",
              display: "$WF_80_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            }
          ]
        }
      ]
    },
    {
      id: 113,
      title: "Contract Information",
      workflows: [
        {
          id: 39,
          title: "Documents",
          notificationName: "Document",
          abbreviation: "Documents-",
          actioningParty: "PM",
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            actionTab: {
              actionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            }
          }
        },
        {
          id: 44,
          title: "Project Bank Accounts",
          notificationName: "Project Bank Account",
          abbreviation: "BankAccount-",
          actioningParty: "PM",
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            actionTab: {
              actionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            }
          }
        }
      ],
      placeholders: [
        {
          replacementKey: "Resources",
          values: []
        },
        {
          replacementKey: "ActionReminders",
          values: []
        }
      ]
    }
  ]
};
export default template;